<template>
  <div class="container news-single">
    <div class="row">
      <div class="col-12 news-single_title">
        <Title :currentName="getName" type="news-single">
          {{ getName }}
        </Title>
      </div>
      <div class="col-12 news-single_poster">
        <NewsPoster :img="getImage" />
      </div>
    </div>
    <div v-if="getDescription" class="row">
      <div class="col-12 news-single_text">
        <PlainText v-html="getDescription" />
      </div>
    </div>
    <div v-if="getDescriptionBeforeCoupon" class="row">
      <div class="col-12 news-single_text">
        <PlainText v-html="getDescriptionBeforeCoupon" />
      </div>
    </div>

    <!--    <div v-if="getPromoCode" class="row news-single_coupon">
      <div class="col-12 col-lg-6 news-single_coupon_title">
        <InnerTitle>
          <template v-slot:title>
            {{ getPromoCode.name }}
          </template>
          <template v-slot:subtitle>
            {{ getPromoCode.description }}
          </template>
        </InnerTitle>
      </div>
      <div class="col-12 col-lg-6">
        <div class="news-single_coupon_inner">
          <Coupon :code="getPromoCode.code" />
          <div @click="copy(getPromoCode.code)" class="news-single_coupon_copy">
            <div>
              <font-awesome-icon :icon="['fas', 'copy']" />
            </div>
            <span>скопировать</span>
          </div>
        </div>
      </div>
    </div>-->

    <div v-if="getDescriptionAfterCoupon" class="row">
      <div class="col-12 news-single_text">
        <PlainText v-html="getDescriptionAfterCoupon" />
      </div>
    </div>
    <div class="row news-single_share">
      <div class="col">
        <client-only>
          <Share
            :url="getLocation"
            :title="getName"
            :img="getImage"
            :description="getMetaDescription"
          />
        </client-only>
      </div>
    </div>

    <!--<div class="row news-single_new">
      <div class="col-12 news-single_new_title">
        <InnerTitle>
          <template v-slot:title>
            Новинки меню
          </template>
          </InnerTwitle>
        </innertitle>
      </div>
      <div class="col-12">
        <RecomendedSlider />
      </div>
    </div>-->

    <div v-if="news && news.length" class="row news-single_other">
      <div class="col-12 news-single_other_title">
        <InnerTitle>
          <template v-slot:title>
            Другие новости
          </template>
        </InnerTitle>
      </div>
      <div class="col-12">
        <NewsSlider :news="news" :currentId="currentItemId" />
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/UI/Title'
import InnerTitle from '@/components/UI/InnerTitle'
import NewsPoster from '@/components/page/News/NewsPoster'
import PlainText from '@/components/UI/PlainText'
import Share from '@/components/UI/Share'
import NewsSlider from '@/components/page/NewsSlider'

// import MapNews from '@/components/page/MapNews'
// import RecomendedSlider from '@/components/page/RecomendedSlider'
// import Coupon from '@/components/UI/Coupon'

export default {
  components: {
    Title,
    InnerTitle,
    NewsPoster,
    PlainText,
    // Coupon,
    Share,
    // MapNews,
    // RecomendedSlider,
    NewsSlider,
  },
  computed: {
    currentItemId () {
      return this.data.id || 0
    },
    getData () {
      return this.data || null
    },
    getName () {
      return this.data ? this.data.name : ''
    },
    getImage () {
      return this.data ? this.data.image : ''
    },
    getDescription () {
      return this.data ? this.data.description : ''
    },
    getDescriptionBeforeCoupon () {
      return this.data ? this.data.descriptionBeforePromoCode : ''
    },
    getDescriptionAfterCoupon () {
      return this.data ? this.data.descriptionAfterPromoCode : ''
    },
    getPromoCode () {
      return this.data ? this.data.promoCode : ''
    },
    getMetaTitle () {
      if (this.data) {
        return this.data.metaTitle
          ? this.data.metaTitle
          : `${this.data.name} | СУШИСЕТ`
      }
      return ''
    },
    getMetaDescription () {
      if (this.data) {
        return this.data.metaDescription
          ? this.data.metaDescription
          : `${this.data.name} — новости службы доставки СУШИСЕТ.`
      }
      return ''
    },
    getLocation () {
      return process.client ? (location ? location.href : '') : ''
    },
  },
  async asyncData ({ $axios, store, route, error }) {
    try {
      const api = store.getters['api/getNewsSingle'](route.params.id)
      const res = await $axios.get(api)
      const data = res.data.data

      const listApi = store.getters['api/getNews']
      const listRes = await $axios.get(listApi)
      const news = listRes.data.items

      return {
        data,
        news,
      }
    } catch (e) {
      error({ statusCode: 404, message: 'region not found' })
    }
  },
  /* head () {
    return {
      title: this.getMetaTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.getMetaDescription,
        },
      ],
    }
  }, */
  methods: {
    copy (text) {
      navigator.clipboard.writeText(text)
    },
  },
}
</script>

<style lang="less">
.news-single {
  margin-top: 20px;

  &_title {
    margin-bottom: 10px;
  }

  .text {
    font-size: 14px;
    font-family: 'Roboto', Arial, sans-serif;
    font-weight: 300;
    font-size: initial;
    line-height: 1.3;
  }

  &_poster {
    margin-bottom: 32px;
  }

  &_text {
    margin-bottom: 36px;
  }

  &_coupon {
    align-items: center;
    margin-bottom: 48px;

    &_title {
      @media screen and (max-width: 992px) {
        margin-bottom: 35px;
      }
    }

    &_inner {
      display: flex;
      align-items: center;

      @media screen and (max-width: 992px) {
        flex-direction: column;
      }
    }

    &_copy {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      align-items: center;
      cursor: pointer;

      @media screen and (max-width: 992px) {
        margin-top: 53px;
      }

      div {
        width: 41px;
        height: 41px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        border-radius: 50%;
        box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
      }

      span {
        font-family: 'Roboto', Arial, sans-serif;
        font-weight: 300;
        font-size: 14px;
        text-align: center;
        margin-top: 4px;
      }
    }
  }

  &_share {
    margin-bottom: 38px;
  }

  &_map {
    margin-bottom: 36px;
  }

  &_new {
    margin-bottom: 50px;

    &_title {
      margin-bottom: 34px;
    }

    .swiper {
      &-container {
        padding-top: 10px;
        padding-bottom: 60px;
        margin-top: -10px;
        margin-bottom: -30px;
      }

      &-wrapper {
        height: auto;
      }

      &-slide {
        border-radius: 30px;
        box-shadow: 0 17px 46px -14px rgba(0, 0, 0, 0.15);
        overflow: hidden;
      }

      &-button-prev,
      &-button-next {
        color: #003cff;
        opacity: 0;
        transition: all 0.3s;
      }
    }
  }

  &_other {
    margin-bottom: 50px;

    &_title {
      margin-bottom: 34px;
    }
  }
}
</style>
